// src/components/HeaderLogged.js
import React, { useEffect, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';

function HeaderLogged() {
  const navigate = useNavigate();
  const [isStaff, setIsStaff] = useState(false);

  const handleLogout = async () => {
    const token = localStorage.getItem('token');
    const refresh = localStorage.getItem('refresh');
    // Гасим refresh на сервере: иначе он оставался действительным после выхода
    if (refresh) {
      try {
        await fetch('/api/logout/', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ refresh }),
        });
      } catch {
        // сеть недоступна — всё равно чистим браузер
      }
    }
    localStorage.removeItem('token');
    localStorage.removeItem('refresh');
    navigate('/', { replace: true });
  };

  useEffect(() => {
    // если нет токена — сразу домой
    const token = localStorage.getItem('token');
    if (!token) {
      navigate('/', { replace: true });
      return;
    }
    // подтянем профиль, чтобы узнать is_staff
    fetch('/api/users-logic/me/', {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
    })
      .then(res => res.json())
      .then(data => {
        if (data.is_staff) {
          setIsStaff(true);
        }
      })
      .catch(() => {
        // в случае ошибки выкидываем на главную
        localStorage.removeItem('token');
        navigate('/', { replace: true });
      });
  }, [navigate]);

  return (
    <header className="bg-[#0F2C5E] text-white flex flex-col sm:flex-row items-center px-4 py-3">
      <Link to="/dashboard" className="w-full sm:w-auto">
        <div className="flex items-center space-x-3">
          <img
            src="/logo.png"
            alt="Logo"
            className="h-12 w-12 rounded-xl"
          />
          <span className="font-bold text-xl">2290Pay.org</span>
        </div>
      </Link>

      {/* Компактный баннер с ценами */}
      <Link
        to="/pricing"
        className="mt-2 sm:mt-0 sm:ml-5 flex items-center gap-1.5 bg-[#E4F2FF] text-[#0F2C5E] rounded-full px-3 py-1 text-xs font-semibold hover:bg-white transition whitespace-nowrap"
        title="See all pricing"
      >
        Form 2290 e-file from $19.99
        <span className="underline underline-offset-2">Pricing</span>
      </Link>

      <div className="flex space-x-3 sm:ml-auto justify-end mt-1 sm:mt-0">
        <Link
          to="/"
          className="px-3 py-1.5 text-white border border-white/60 hover:bg-white hover:text-[#0F2C5E] transition text-sm"
        >
          Main Site
        </Link>
        {isStaff && (
          <Link
            to="/admin"
            className="px-3 py-1.5 bg-white text-[#0F2C5E] border border-white hover:bg-gray-200 transition text-sm"
          >
            Admin Dashboard
          </Link>
        )}
        <Link
          to="/user"
          className="px-3 py-1.5 bg-white text-[#0F2C5E] border border-white hover:bg-gray-200 transition text-sm"
        >
          Profile
        </Link>
        <button
          onClick={handleLogout}
          className="px-3 py-1.5 bg-white text-[#0F2C5E] border border-white hover:bg-gray-200 transition text-sm"
        >
          Log out
        </button>
      </div>
    </header>
  );
}

export default HeaderLogged;
